class MulticolumnTeam extends HTMLElement {
  constructor() {
    super();
    this.slectors = {
      viewAllButton: '[view-all-team]',
      hiddenCards: '[data-reveal="false"]',
    };
    this.init();
  }
  init() {
    this.viewAllButton = this.querySelector(this.slectors.viewAllButton);
    this.hiddenCards = this.querySelectorAll(this.slectors.hiddenCards);
    if (this.viewAllButton) {
      this.viewAllButton.addEventListener('click', this.revealCards.bind(this));
    }
  }
  revealCards(event) {
    event.preventDefault();
    this.hiddenCards.forEach(card => { card.setAttribute('data-reveal', 'true'); });
    this.viewAllButton.parentElement.style.display = 'none';
  }
}
customElements.define('multicolumn-team', MulticolumnTeam);